import axios from "axios";
import { GenOrderNum, parseXmlToJson } from "./BacFunctions";
import { preProcess } from "./ProcessOrder";

const MerchantInfo = {
  MERCH_ID: process.env.REACT_APP_MERCH_ID,
  MERCH_PWD: process.env.REACT_APP_MERCH_PWD,
  ACQUIRED_ID: process.env.REACT_APP_ACQUIRED_ID,
};

const makeOrderCard = async ({
  setCheckoutState,
  shippingDetails,
  setOrderNumber,
  orderInfo,
  total,
  totalUSD,
}) => {
  const ResponseURL = process.env.REACT_APP_apiUrl + "/getTransactionResult";

  const orderNumber = GenOrderNum();
  setOrderNumber(orderNumber);
  orderInfo.orderNumber = orderNumber;
  shippingDetails.orderInfo.orderNumber = orderNumber;
  setCheckoutState(shippingDetails);
  let response;
  if (shippingDetails.cardInfo.cardNumber.value[0] === "3") {
    let xmlAR = await preProcess({
      shippingDetails,
      MerchantInfo,
      orderNumber,
      total,
      totalUSD,
    });

    response = await axios.post(
      process.env.REACT_APP_apiUrl + "/getThreeDSResponse",
      { requestBody: xmlAR, typeRequest: "Authorize" }
    );

    return parseXmlToJson(
      response.data
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&#xD;/g, "")
    );
  } else {
    let xml3ds = await preProcess({
      shippingDetails,
      MerchantInfo,
      orderNumber,
      ResponseURL,
      total,
      totalUSD,
    });

    response = await axios.post(
      process.env.REACT_APP_apiUrl + "/getThreeDSResponse",
      { requestBody: xml3ds, typeRequest: "Authorize3DS" }
    );

    response = response.data
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&#xD;/g, "");
  }
  return response;
};

export { makeOrderCard };
